export const MOBILE_HEADER_HEIGHT = '50px'
export const DESKTOP_HEADER_HEIGHT = '60px'
